module.exports = __webpack_public_path__ + "img/pgd_a_01000.59a2704b.png";